import axios, { AxiosResponse } from 'axios';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { OctResponse } from '../../models/OctResponse';
import { localStorageItem } from '../../utils/LocalStorage';
import { paramsConfig } from '../../utils/ParamsUtils';
import { sendXMLResponse, validateXMLParams } from '../types';

const BASE_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.['apiUrl'] ||
	process.env.REACT_APP_API_URL;

const INS_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.['insApi'] ||
	process.env.REACT_APP_API_URL;

export const getPatientList = async (params: any): Promise<AxiosResponse<any>> => {
	return axios.get<AxiosResponse<any>>(`${BASE_URL}/ins-visit/search`, {
		params,
	});
};

export const getPatientInfo = async (patientId: any): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/ins-visit/${patientId}/patient-info`
	);
	return data;
};

export const getPatientListSummary = async (params: any): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/ins-visit/summary-statuses`, {
		params,
	});
	return data;
};

export const getInsuranceServices = async (paymentCode: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/ins-visit/visit-code/${paymentCode}/payment-info`
	);
	return data;
};

export const getInsuranceInvoices = async (visitCode: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/ins-visit/visit-code/${visitCode}/invoices`
	);
	return data;
};

export const getInsuranceInvoiceDetail = async (invoiceId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/ins-visit/inv/${invoiceId}`);
	return data;
};

export const approveInsurance = async (patientId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${BASE_URL}/ins-visit/${patientId}/approve`
	);
	return data;
};

export const cancelApproveInsurance = async (patientId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${BASE_URL}/ins-visit/${patientId}/cancel-approval`
	);
	return data;
};

export const getXmlData = async (xmlTabCode: string, params: {
	patientCode: string,
	visitCode: string,
}): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${INS_URL}/xml-processor/type/${xmlTabCode}`,
		paramsConfig(params)
	);
	return data;
};

export const validateXML = async (params: validateXMLParams): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${INS_URL}/xml/validate`,
		params
	);
	return data;
};

export const exportInsuranceXML = async (requestBody: validateXMLParams): Promise<any> => {
	const { data } = await axios.post(
		`${INS_URL}/xml/summary`,
		requestBody
	);
	return data;
};

export const gettXmlTabs = async (params: {
	patientCode: string,
	visitCode: string,
}): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${INS_URL}/xml-processor/existing-xml`,
		paramsConfig(params)
	);
	return data;
};

export const downloadXML = async (params: validateXMLParams): Promise<AxiosResponse<any>> => {
	const form = new FormData();
	Object.entries(params).forEach(([key, value]) => {
		form.set(key, value);
	});
	const response = await axios.post<AxiosResponse<any>>(
		`${INS_URL}/xml-processor/download`,
		form
	);
	return response;
};

export const exportCheckinXML = async (requestBody: validateXMLParams): Promise<any> => {
	const { data } = await axios.post(
		`${INS_URL}/xml/check-in-encode`,
		requestBody
	);
	return data;
};

export const sendXMLCheckIn = async (
	requestBody: validateXMLParams
): Promise<OctResponse<sendXMLResponse>> => {
	const { data } = await axios.post<OctResponse<sendXMLResponse>>(
		`${INS_URL}/egw/checkin/send`,
		requestBody
	);
	return data;
};

export const sendXMLPayment = async (
	requestBody: validateXMLParams
): Promise<OctResponse<sendXMLResponse>> => {
	const { data } = await axios.post<OctResponse<sendXMLResponse>>(
		`${INS_URL}/egw/payment/send`,
		requestBody
	);
	return data;
};